import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'CFP_UPDATE',
    smsDelete : 'CFP_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        cfp:[],
        cfp_detail:{},
       
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        cfpLoading: false,
        cfpError: false,

        
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_CFP(state, cfp) {
            state.cfp = cfp;
        },
        SET_CFP_DETAIL(state, detail) {
            state.cfp_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },


        CFP_LOADING (state, loading) {
            state.cfpLoading = loading;
        },

        CFP_ERROR (state, hasError) {
            state.cfpError = hasError;
        },
        


       
    },

    actions: {
        
        async addCFP ({commit, dispatch}, payload) {
            commit('CFP_LOADING', true);
            commit('CFP_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.cfp_create, payload.cfp, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
               
               
                return response

            }catch (e) {
                commit('CFP_ERROR', true);
            }finally {
                commit('CFP_LOADING', false);
            }
        },

        async fetchCFPDetail ({ commit },payload) {
            commit('CFP_LOADING', true);
            commit('CFP_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.cfp_details + payload, config);
                let response = result.data.data

                commit('SET_CFP_DETAIL', response);

            } catch(error) {
                commit('CFP_ERROR', true);
            }
            finally {
                commit('CFP_LOADING', false);
            }
        },

       


        async fetchCFPList ({ commit }) {
            commit('CFP_LOADING', true);
            commit('CFP_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.cfp_list, config);
                let response = result.data

                commit('SET_CFP', response.data);

            } catch(error) {
                commit('CFP_ERROR', true);
            }
            finally {
                commit('CFP_LOADING', false);
            }
        },


    
        async updateCFP ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.patch(V1API.cfp_edit+payload.cfp_id, payload.cfp, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
              
                return response

            }catch (e) {
                commit('CFP_ERROR', true);
            }finally {
                commit('CFP_LOADING', false);
            }
        },

        
        async deleteCFP({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };
          
            let response = await axios.delete(V1API.cfp_delete+payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCFPList')
            
            return response
        },


        async updateStatusToggle({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };
            console.log(payload.delete)
            let response = await axios.get(V1API.cfp_status_toggle+payload.cfp_id, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCFPList')
            
            return response
        },


    },

    getters: {}
}
